<template>
    <div class="modal fade" id="bulkCostErrorModal" tabindex="-1" role="dialog" aria-labelledby="bulkCostErrorModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="bulkCostErrorModalLabel">{{ $t('views.inventory.modals.bulkCostError.title') }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>SKU</th>
                                    <th>{{ $t('views.inventory.modals.bulkCostError.error') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(message, index) in messages" :key="index">
                                    <td>{{ message.sku }}</td>
                                    <td>
                                        {{
                                            message.error
                                                .split(',')
                                                .map((error) => $t('views.inventory.modals.bulkCostError.errors.' + error.trim()))
                                                .join(', ')
                                        }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-white" @click="handleDontShowAgain">
                        {{ $t('views.inventory.modals.bulkCostError.dontShowAgain') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="handleExport">
                        {{ $t('views.inventory.modals.bulkCostError.export') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { modalManager } from '@/modal-manager.service'

export default {
    name: 'BulkCostErrorModal',
    props: {
        messages: {
            type: Array,
            required: true,
        },
        processId: {
            type: String,
            required: true,
        },
    },
    methods: {
        handleDontShowAgain() {
            this.$emit('dont-show-again', this.processId)
            modalManager.hideModal('bulkCostErrorModal')
        },
        handleExport() {
            const csvContent = [['SKU', 'Error'], ...this.messages.map((msg) => [msg.sku, msg.error])].map((row) => row.join(',')).join('\n')

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
            const link = document.createElement('a')
            const url = URL.createObjectURL(blob)

            link.setAttribute('href', url)
            link.setAttribute('download', 'bulk_cost_errors.csv')
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
    },
    beforeUnmount() {
        modalManager.destroyModal('bulkCostErrorModal')
    },
}
</script>

<style scoped>
.table-responsive {
    max-height: 400px;
    overflow-y: auto;
}

.table thead th {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
}

.table {
    margin-bottom: 0;
}
</style>
